// Copyright (c) 2026 Goffy. All Rights Reserved.

import { useEffect, useRef } from 'react';

import { useI18n } from '@/i18n';
import { offerPlayUpdate } from '@/services/appUpdate';

/** Offers a newer Play build once per app launch. A no-op off Android and outside Play installs. */
export function useAppUpdatePrompt() {
  const { t } = useI18n();
  const offered = useRef(false);

  useEffect(() => {
    if (offered.current) return;
    offered.current = true;
    void offerPlayUpdate({
      title: t('appUpdate.readyTitle'),
      message: t('appUpdate.readyMessage'),
      restart: t('appUpdate.restart'),
      later: t('appUpdate.later'),
    });
  }, [t]);
}
